<template>
  <Modal @close="$emit('close')" classes="col-lg-5">
    <div class="body my-2 col-lg-10 mx-auto text-center" slot="body">
      <h2><strong>Feliz Día de Maestro!!</strong></h2>
      <div class="row ">
        <div class="col-lg-10 mx-auto text-center mt-5">
          <button class="button primary" @click="$emit('close')">
            Aceptar
          </button>
        </div>
      </div>
    </div>
  </Modal>
</template>

<script>
import Modal from "@/components/Modal";

export default {
  name: "TeacherDayModal",
  components: {
    Modal,
  },
  data() {
    return {
      showSpinner: false,
    };
  },
  watch: {},
};
</script>

<style lang="scss" scoped></style>
